export const PayoutData = [
  {
    id:"1",
    ID: "#1010",
    Date: "22Aug2025",
    Amount: "$160",
    PaymentMethod: "Paypal",
    Status: "Paid",
  },
  {
    id:"2",
    ID: "#1009",
    Date: "10Aug2025",
    Amount: "$180",
    PaymentMethod: "BankTransfer",
    Status: "Pending",
  },
  {
    id:"3",
    ID: "#1008",
    Date: "26Jul2025",
    Amount: "$200",
    PaymentMethod: "Stripe",
    Status: "Paid",
  },
  {
    id:"4",
    ID: "#1007",
    Date: "12Jul2025",
    Amount: "$220",
    PaymentMethod: "Paypal",
    Status: "Paid",
  },
  {
    id:"5",
    ID: "#1006",
    Date: "02Jul2025",
    Amount: "$170",
    PaymentMethod: "Stripe",
    Status: "Paid",
  },
  {
    id:"6",
    ID: "#1005",
    Date: "25Jun2025",
    Amount: "$150",
    PaymentMethod: "BankTransfer",
    Status: "Paid",
  },
  {
    id:"7",
    ID: "#1004",
    Date: "17Jun2025",
    Amount: "$130",
    PaymentMethod: "Paypal",
    Status: "Paid",
  },
  {
    id:"8",
    ID: "#1003",
    Date: "04Jun2025",
    Amount: "$190",
    PaymentMethod: "BankTransfer",
    Status: "Paid",
  },
  {
    id:"9",
    ID: "#1002",
    Date: "20May2025",
    Amount: "$140",
    PaymentMethod: "Paypal",
    Status: "Cancelled",
  },
  {
    id:"10",
    ID: "#1001",
    Date: "15May2025",
    Amount: "$110",
    PaymentMethod: "Stripe",
    Status: "Paid",
  },
];
